import { Badge, Box, Button, Modal, SpaceBetween } from '@amzn/awsui-components-react';
import React from 'react';
import CustomTag from 'src/models/accounting-calendar/CustomTag';

interface Props {
    /** Display date (e.g. "2026-06-22" or a friendly formatted date). */
    dateLabel: string;
    /** Tags scheduled for this date. */
    tags: CustomTag[];
    /** Called when the user picks a tag from the list. */
    onSelectTag: (tag: CustomTag) => void;
    /** Called when the user dismisses the modal. */
    onClose: () => void;
}

/** Lists every tag for a given date so the user can drill into any one. */
export default function DayTagsModal(props: Props) {
    const { dateLabel, tags, onSelectTag, onClose } = props;
    return (
        <Modal
            data-testid="dayTagsModal"
            visible={true}
            header={`Tags for ${dateLabel}`}
            size="medium"
            onDismiss={onClose}
            footer={
                <Box float="right">
                    <Button variant="normal" onClick={onClose}>Close</Button>
                </Box>
            }
        >
            <SpaceBetween direction="vertical" size="xs">
                {tags.map(tag => (
                    <div
                        key={tag.tagId}
                        className="acctCalendarTagListItem"
                        data-testid={`tagListItem-${tag.tagId}`}
                        onClick={() => onSelectTag(tag)}
                    >
                        <div className="acctCalendarTagListItemRow">
                            <Badge color={tag.isRecurring ? 'blue' : 'grey'}>
                                {tag.isRecurring ? 'Recurring' : 'One-time'}
                            </Badge>
                            <span className="acctCalendarTagListItemName" title={tag.tagEventName}>
                                {tag.tagEventName}
                            </span>
                        </div>
                    </div>
                ))}
            </SpaceBetween>
        </Modal>
    );
}
